// Filtres Tout / Food / Drink (cartes : parts/components/component_foodtruck_card.php)
function filterFoodtrucks() {
    document.querySelectorAll('.block_foodtrucks').forEach(function (block) {
        const buttons = block.querySelectorAll('.foodtrucks_filter-js');
        const items   = block.querySelectorAll('.listing_item-js');

        buttons.forEach(function (button) {
            button.addEventListener('click', function () {
                const filter = button.dataset.filter;

                buttons.forEach(function (btn) {
                    btn.classList.toggle('active', btn === button);
                    btn.setAttribute('aria-selected', btn === button ? 'true' : 'false');
                });

                items.forEach(function (item) {
                    const types   = (item.dataset.types || '').split(' ');
                    const visible = filter === 'all' || types.includes('all') || types.includes(filter);
                    item.classList.toggle('is-hidden', !visible);
                });
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', filterFoodtrucks);
